import { filterObjectByKey } from '../utils/filterObjectByKey';
import { imageObject } from '../utils/imageObject';
import { createBreadcrumbsList } from '../utils/createBreadcrumbsList';

import type { ImageObjectType, PageStructuredDataArgs } from '../types';

import config from '../structured_data.config.json';

const { website, organization } = config;

type PostPageStructuredDataArgs = {
  headline: string;
  datePublished: string;
  dateModified: string;
  author: {
    name: string;
    image: ImageObjectType;
  };
} & PageStructuredDataArgs;

function postPageStructuredData({
  name,
  urlSlug,
  headline,
  dateModified,
  datePublished,
  image,
  author,
  breadcrumbs,
  baseUrl,
}: PostPageStructuredDataArgs) {
  const authorId = new URL(`/${baseUrl}/authors/${author.name}`, website.url);
  const postUrl = new URL(`/${baseUrl}/${urlSlug}`, website.url);

  return JSON.stringify({
    '@context': 'https://schema.org',
    '@graph': [
      // include type, name, and id only
      (({ '@type': type, name, '@id': id }) => ({ '@type': type, name, '@id': id }))(organization),
      filterObjectByKey(website, ['potentialAction']),
      {
        '@type': 'WebPage',
        '@id': `${postUrl}#webpage`,
        url: postUrl,
        name,
        datePublished,
        dateModified,
        inLanguage: website.inLanguage,
        author: {
          '@id': authorId,
        },
        isPartOf: {
          '@id': website['@id'],
        },
        primaryImageOfPage: {
          '@id': image.url,
        },
        breadcrumb: {
          '@id': `${postUrl}#breadcrumb`,
        },
      },
      imageObject({ image }),
      {
        '@type': 'Person',
        '@id': authorId,
        name: author.name,
        image: imageObject({ image: author.image }),
        worksFor: {
          '@id': organization['@id'],
        },
      },
      {
        '@type': 'Article',
        '@id': `${postUrl}#article`,
        url: postUrl,
        name,
        headline,
        datePublished,
        dateModified,
        inLanguage: website.inLanguage,
        author: {
          '@id': authorId,
        },
        isPartOf: {
          '@id': `${postUrl}#webpage`,
        },
        mainEntityOfPage: {
          '@id': `${postUrl}#webpage`,
        },
        publisher: {
          '@id': organization['@id'],
        },
        image: {
          '@id': image.url,
        },
      },
      createBreadcrumbsList({ websiteUrl: website.url, baseUrl, urlSlug, breadcrumbs }),
    ],
  });
}

export default postPageStructuredData;
